
import {getCurrentUser, fetchAuthSession} from '@aws-amplify/auth'
import $global from 'stores/global'

export default {
  data() {
    return {
      cognito_pool: COGNITO_POOL,
      backend_url: BACKEND_URL,
      user: undefined,
      session: undefined
    }
  },
  async mounted() {
    this.user = await getCurrentUser()
    this.session = await fetchAuthSession()
  },
  methods: {
    async logout() {
      await $global.logout()
    }
  }
}
